import api from '@services/api';
import {
  CustomerApi,
  CustomerPersonalDataDto,
  ReferenceApi,
  VaspDto,
  WalletDto,
} from '@services/generated';
import { handleErrors } from '@services/helpers';
import { rootApi } from '@store/root-api';
import appHelpers from '@utils/app-urls';

const API_URL = appHelpers.getEndpointUrl();

const referencesClient = new ReferenceApi(
  undefined,
  new URL(API_URL, process.env.REACT_API_URL).href,
  api,
);

const customerClient = new CustomerApi(
  undefined,
  new URL(API_URL, process.env.REACT_API_URL).href,
  api,
);

interface CreateOrUpdateCryptoAccount {
  wallet: WalletDto;
  otpFlowTypeCode?: string;
  TwoFA?: string;
}
const cryptAccountsApi = rootApi.injectEndpoints({
  endpoints: builder => ({
    getVasps: builder.query<VaspDto[], void>({
      queryFn: () => handleErrors(() => referencesClient.listVasps()),
    }),
    getPersonalData: builder.query<CustomerPersonalDataDto, void>({
      queryFn: () => handleErrors(() => customerClient.getPersonalData()),
    }),
    getCryptoAccount: builder.query<WalletDto, string>({
      queryFn: productCode =>
        handleErrors(() => customerClient.getWallet(productCode)),
      providesTags: [{ type: 'CustomerAccount' }],
    }),
    createOrUpdateCryptoAccount: builder.mutation<
      WalletDto,
      CreateOrUpdateCryptoAccount
    >({
      queryFn: request =>
        handleErrors(() =>
          request.wallet?.accountId
            ? customerClient.updateWallet(
                request.TwoFA,
                request.otpFlowTypeCode,
                request.wallet,
              )
            : customerClient.createWallet(
                request.TwoFA,
                request.otpFlowTypeCode,
                request.wallet,
              ),
        ),
      invalidatesTags: [{ type: 'CustomerAccount' }, { type: 'UserProfile' }],
    }),
    createOrUpdateCustomerPersonalData: builder.mutation<
      void,
      CustomerPersonalDataDto
    >({
      queryFn: request =>
        handleErrors(() => customerClient.createOrUpdatePersonalData(request)),
      invalidatesTags: [{ type: 'CustomerPersonalData' }],
    }),
  }),
});

export const {
  useGetVaspsQuery,
  useGetPersonalDataQuery,
  useGetCryptoAccountQuery,
  useCreateOrUpdateCryptoAccountMutation,
  useCreateOrUpdateCustomerPersonalDataMutation,
} = cryptAccountsApi;
